import { Moon, Sun } from "@phosphor-icons/react";
import { useTheme } from "../contexts/ThemeContext";

export default function ThemeToggle({ size = "default" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? "Activar modo claro" : "Activar modo oscuro"}
      data-testid="theme-toggle"
      title={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className="relative inline-flex items-center flex-shrink-0 rounded-full transition-colors duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-yellow-400/60"
      style={{
        width: "50px",
        height: "26px",
        backgroundColor: isDark ? "#FFD700" : "#6B7280",
      }}
    >
      {/* Track */}
      {/* Thumb */}
      <span
        className="absolute flex items-center justify-center w-[20px] h-[20px] rounded-full bg-white shadow-md transition-transform duration-300 ease-in-out"
        style={{
          transform: isDark ? "translateX(26px)" : "translateX(3px)",
        }}
      >
        {isDark ? (
          <Moon className="w-[11px] h-[11px] text-yellow-700" weight="fill" />
        ) : (
          <Sun className="w-[11px] h-[11px] text-yellow-500" weight="fill" />
        )}
      </span>
    </button>
  );
}
